var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/shield"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.45 11.1498L27.5 20.5498C21.75 22.6998 17.05 29.4998 17.05 35.5998V72.7498C17.05 78.6498 20.95 86.3998 25.7 89.9498L47.2 106C54.25 111.3 65.85 111.3 72.9 106L94.4 89.9498C99.15 86.3998 103.05 78.6498 103.05 72.7498V35.5998C103.05 29.4498 98.3501 22.6498 92.6001 20.4998L67.65 11.1498C63.4 9.5998 56.6 9.5998 52.45 11.1498Z",
    stroke: "#123EC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.1924adbeecb2a2a5085068a2cd4b9d36.svg";
export { ForwardRef as ReactComponent };